<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <!-- <div class="container mx-auto px-4"> -->
      <div class="grid md:grid-cols-2 gap-6 items-stretch">
        <!-- Left Side: Full Image -->
        <div class="bg-white p-6 md:p-12 flex flex-col justify-center">
          <h2 class="text-2xl md:text-4xl mb-4">{{ t("Onze Belofte") }}</h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
              <h3 class="text-lg sm:text-xl font-semibold mb-3">{{ t("Kwaliteit") }}</h3>
              <p
                class="text-base sm:text-lg"
              >{{ t("We streven naar de hoogste kwaliteit in onze cursussen en leermiddelen. We werken voortdurend aan verbetering en zorgen voor up-to-date informatie.") }}</p>
            </div>

            <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
              <h3 class="text-lg sm:text-xl font-semibold mb-3">{{ t("Toegankelijkheid") }}</h3>
              <p
                class="text-base sm:text-lg"
              >{{ t("We maken onze cursussen toegankelijk voor iedereen, ongeacht hun achtergrond of ervaring. We bieden verschillende leerniveaus en ondersteuning om je te helpen slagen.") }}</p>
            </div>

            <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
              <h3 class="text-lg sm:text-xl font-semibold mb-3">{{ t("Duurzaamheid") }}</h3>
              <p
                class="text-base sm:text-lg"
              >{{ t("We investeren in duurzame leermiddelen en technologie. We streven naar een ecologische en verantwoorde leeromgeving.") }}</p>
            </div>

            <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
              <h3 class="text-lg sm:text-xl font-semibold mb-3">{{ t("Innovatie") }}</h3>
              <p
                class="text-base sm:text-lg"
              >{{ t("We zijn voortdurend op zoek naar nieuwe manieren om onze cursussen te verbeteren en te innoveren. We volgen de nieuwste ontwikkelingen in de zorg en implementeren deze in onze leermaterialen.") }}</p>
            </div>
          </div>
        </div>

        <!-- Right Side: Content with Icons -->
        <div class="w-full h-full hidden md:block">
          <img
            :alt="t('Pointing arrow to steps')"
            src="@/../img/home/all-hand.jpg"
            class="w-full h-full object-cover rounded-lg shadow-lg"
          />
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

